"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Children = exports.Line = exports.DiscontinuousVerticalLine = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

var DiscontinuousVerticalLine = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n"])));

exports.DiscontinuousVerticalLine = DiscontinuousVerticalLine;
DiscontinuousVerticalLine.displayName = 'DiscontinuousVerticalLine';

var Line = _styledComponents["default"].canvas(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n"])));

exports.Line = Line;
Line.displayName = 'Line';

var Children = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 20px;\n"])));

exports.Children = Children;
Children.displayName = 'Children';